import { getSession } from "@/lib/auth/session";
import { logActivity } from "@/lib/db/audit";

export const dynamic = "force-dynamic";

export default async function DashboardPage() {
  const session = await getSession();
  const user = session!.user;
  const firstName = user.name.split(/\s+/)[0] || user.email;
  const today = new Date().toLocaleDateString("fr-FR", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });

  void logActivity({
    type: "superadmin.dashboard_view",
    title: "Vue tableau de bord cross-tenant",
    user_id: user.id,
  });

  return (
    <div className="px-8 pt-10 lg:px-12 lg:pt-14">
      <header className="flex flex-col gap-1.5 mf-fade-in">
        <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground">
          {today}
        </p>
        <h1 className="text-3xl font-semibold tracking-tight text-foreground">
          Bonjour {firstName} <span aria-hidden="true">👋</span>
        </h1>
        <p className="text-sm text-muted-foreground">
          Vue d&apos;ensemble du SaaS missioflow.
        </p>
      </header>
    </div>
  );
}
